import { stats } from '@/mocks/faq';

export default function StatsSection() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-4xl font-heading font-bold text-primary-500">
                {stat.value}
              </div>
              <div className="mt-1.5 text-sm text-foreground-600">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}